import React, { Component, Fragment } from "react";
import { ErrorMessage } from "formik";
import ReactTooltip from "react-tooltip";
import TermsOfBusinessModal from "../general/TermsOfBusinessModal";
import PrivacyPolicyModal from "../general/PrivacyPolicyModal";
import {
  Wrapper,
  Input,
  Label,
  LabelText,
  ModalTrigger,
  Error,
} from "./styles/checkbox-styles";

interface Props {
  field: unknown;
  form: unknown;
  name: string;
  isError: boolean;
  error: string;
  labelText: string;
  modalTriggerName: string;
  ariaLabel: string;
  disabled: boolean;
  privacyPolicy: boolean;
}

interface State {
  termsModalActive: boolean;
  privacyModalActive: boolean;
}

export class CheckboxWithTermsModal extends Component<Props, State> {
  state = {
    termsModalActive: false,
    privacyModalActive: false,
  };

  toggleTermsModal = (): void => {
    const { termsModalActive } = this.state;
    this.setState({ termsModalActive: !termsModalActive });
  };

  togglePrivacyModal = (): void => {
    const { privacyModalActive } = this.state;
    this.setState({ privacyModalActive: !privacyModalActive });
  };

  render(): React.ReactNode {
    const { field, ...props } = this.props;
    const {
      privacyPolicy,
      name,
      isError,
      ariaLabel,
      disabled,
      error,
      labelText,
      modalTriggerName,
    } = props;
    const { termsModalActive, privacyModalActive } = this.state;

    return (
      <Fragment>
        {termsModalActive && (
          <TermsOfBusinessModal toggleTermsModal={this.toggleTermsModal} />
        )}
        {privacyModalActive && (
          <PrivacyPolicyModal togglePrivacyModal={this.togglePrivacyModal} />
        )}
        <Wrapper>
          <ReactTooltip
            place="bottom"
            type="dark"
            effect="solid"
            aria-haspopup="true"
            id="portal-terms"
          />
          <Input {...field} {...props} id={name} />
          <Label htmlFor={name} isError={isError} disabled={disabled}>
            <LabelText aria-label={ariaLabel} disabled={disabled}>
              {labelText}
              <ModalTrigger
                disabled={disabled}
                data-tip={`View ${modalTriggerName}`}
                data-for="portal-terms"
                aria-label={`View ${modalTriggerName}`}
                isError={isError}
                href="#"
                onClick={this.toggleTermsModal}
                title=""
              >
                {modalTriggerName}
              </ModalTrigger>
              {privacyPolicy && (
                <Fragment>
                  {" "}
                  and{" "}
                  <ModalTrigger
                    disabled={disabled}
                    data-tip="View Privacy Policy"
                    data-for="portal-terms"
                    aria-label="View Privacy Policy"
                    isError={isError}
                    href="#"
                    onClick={this.togglePrivacyModal}
                    title=""
                  >
                    privacy policy
                  </ModalTrigger>
                </Fragment>
              )}
              .
            </LabelText>
          </Label>
          <Error aria-label={error}>
            <ErrorMessage name={name} />
          </Error>
        </Wrapper>
      </Fragment>
    );
  }
}

export default CheckboxWithTermsModal;
